// @flow
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './styles.less';

type Props = {
  children: React$Node,
  in: boolean
};
export default class ExpandDown extends Component<Props> {
  props: Props;

  render() {
    const { children, ...props } = this.props;

    return (
      <CSSTransition
        classNames={{
          enter: styles.transitionEnter,
          enterActive: styles.transitionEnterActive
        }}
        timeout={1000}
        unmountOnExit
        {...props}
      >
        {children}
      </CSSTransition>
    );
  }
}
